export const useIsMobileBrowser = (): boolean => {
  if (window.navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|bada|Symbian|Palm|CriOS|BlackBerry|IEMobile|WindowsMobile|Opera Mini/i) != null) {
    return true
  }

  return false
}
